import { render, staticRenderFns } from "./InsertConcept.vue?vue&type=template&id=c83521fc&scoped=true"
import script from "./InsertConcept.vue?vue&type=script&lang=js"
export * from "./InsertConcept.vue?vue&type=script&lang=js"
import style0 from "./InsertConcept.vue?vue&type=style&index=0&id=c83521fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83521fc",
  null
  
)

export default component.exports